import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { DocumentCornSchema } from '../aggregates/documents.js';
export const ImageRotationDegreesSchema = z.union([z.literal(90), z.literal(180), z.literal(270)]);
export const ImageRotationSchema = z.object({
    degrees: ImageRotationDegreesSchema,
});
export const RotateImageApiSchema = {
    headers: ApiLambdalerAuthHeaderSchema,
    params: z.object({
        entityId: CornSchema,
        documentCorn: DocumentCornSchema,
    }),
    body: z.object({
        rotation: ImageRotationSchema,
    }),
};
export const RotateImageRequestSchema = RotateImageApiSchema.body
    .merge(RotateImageApiSchema.params)
    .merge(RotateImageApiSchema.headers);
